import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { FacilityInformationType } from '@cargos/sprintpay-services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FACILITY_INFO } from '../../pages/facility-information/facility-information';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false,
})
export class FooterComponent implements OnInit, OnDestroy {
    public dataSource: FacilityInformationType[];
    public showFooter: boolean = false;
    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private router: Router) {}

    ngOnInit(): void {
        this.dataSource = FACILITY_INFO;

        this.updateShowFooter();
        this.router.events.pipe(takeUntil(this.unsubscribe$)).subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.updateShowFooter();
            }
        });
    }

    private updateShowFooter(): void {
        this.showFooter = this.router.url.endsWith('search-awb');
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
